import { render, staticRenderFns } from "./Programmers.vue?vue&type=template&id=fcb635f0&scoped=true&"
import script from "./Programmers.vue?vue&type=script&lang=js&"
export * from "./Programmers.vue?vue&type=script&lang=js&"
import style0 from "./Programmers.vue?vue&type=style&index=0&id=fcb635f0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb635f0",
  null
  
)

export default component.exports